import styled from 'styled-components'

export const LoginContainer = styled.div<{ $showCard: boolean }>`
  width: 100%;
  max-width: ${({ $showCard }) => ($showCard ? '400px' : 'none')};
  margin: ${({ $showCard }) => ($showCard ? '0 auto' : '0')};
  padding: ${({ $showCard }) => ($showCard ? '2rem' : '0')};
  background: ${({ $showCard }) => ($showCard ? 'white' : 'transparent')};
  border-radius: ${({ $showCard }) => ($showCard ? '12px' : '0')};
  box-shadow: ${({ $showCard }) => ($showCard ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none')};

  @media (max-width: 480px) {
    padding: ${({ $showCard }) => ($showCard ? '1.5rem' : '0')};
    box-shadow: none;
    border-radius: 0;
  }
`

export const LoginHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`

export const LoginTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`

export const LoginSubtitle = styled.p`
  font-size: 0.875rem;
  color: #666;
  margin: 0;
`

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #1a1a1a;
`

export const RememberMeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -0.5rem;
`

export const RememberMeWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #666;

  input {
    cursor: pointer;
  }
`

export const ForgotPasswordLink = styled.button`
  background: none;
  border: none;
  padding: 8px 0;
  /* Mobile: Ensure 44px minimum touch target */
  min-height: ${({ theme }) => theme.touchTargets.minimum};
  font-size: 0.875rem;
  /* WCAG AA: brand cyan #0294df fails 4.5:1 on white; darkened to ~5.1:1 */
  color: #0078a8;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: #005c82;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #0294df;
    outline-offset: 2px;
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover {
      color: #0078a8;
      text-decoration: none;
    }

    &:active {
      color: #005c82;
      text-decoration: underline;
    }
  }
`

export const ErrorMessage = styled.div`
  padding: 0.75rem 1rem;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  color: #c00;
  font-size: 0.875rem;
`

export const SuccessMessage = styled.div`
  padding: 0.75rem 1rem;
  background-color: #efe;
  border: 1px solid #cfc;
  border-radius: 6px;
  color: #060;
  font-size: 0.875rem;
`

export const Divider = styled.div`
  position: relative;
  text-align: center;
  margin: 2rem 0;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #e0e0e0;
  }

  span {
    position: relative;
    padding: 0 1rem;
    background-color: white;
    color: #666;
    font-size: 0.875rem;
  }
`

export const SocialLoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const SocialLoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  /* Mobile: Ensure 44px minimum touch target */
  min-height: ${({ theme }) => theme.touchTargets.minimum};
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f5f5f5;
    border-color: #ccc;
  }

  &:focus {
    outline: 2px solid #0294df;
    outline-offset: 2px;
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover {
      background-color: white;
      border-color: #e0e0e0;
    }

    &:active {
      background-color: #f5f5f5;
      border-color: #ccc;
    }
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

export const SignUpPrompt = styled.div`
  text-align: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e0e0e0;
  font-size: 0.875rem;
  color: #666;
`

export const SignUpLink = styled.button`
  background: none;
  border: none;
  padding: 8px 4px;
  /* Mobile: Ensure 44px minimum touch target */
  min-height: ${({ theme }) => theme.touchTargets.minimum};
  margin-left: 0.25rem;
  font-size: 0.875rem;
  /* WCAG AA: brand cyan #0294df fails 4.5:1 on white; darkened to ~5.1:1 */
  color: #0078a8;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: #005c82;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #0294df;
    outline-offset: 2px;
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover {
      color: #0078a8;
      text-decoration: none;
    }

    &:active {
      color: #005c82;
      text-decoration: underline;
    }
  }
`
